exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_wks-ext.js
// module id = 211
// module chunks = 0